import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_4l6t3x36: FaireBrandEntity = {
  token: "b_4l6t3x36",
  type: "brand",
  name: "Hyggelight | The Growing Candle ®",
  avatarUrl:
    "https://cdn.faire.com/fastly/1feb8d0fcd2f0e709b1aea5bb17b2fdd54eaa5eb56194e6d0a32d937905174ba.png",
  bannerUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/5831e238b8f5550273f63a2ed367c997935130b49a47ee584cfe3d1f73d296fc/1555080681.png",
  logoUrl:
    "https://cdn.faire.com/fastly/1feb8d0fcd2f0e709b1aea5bb17b2fdd54eaa5eb56194e6d0a32d937905174ba.png",
  heroImageUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/5831e238b8f5550273f63a2ed367c997935130b49a47ee584cfe3d1f73d296fc/1555080681.png",
  location: "Toledo, OH, USA",
  minimumOrderDollars: 150,
  rating: 4.9,
  reviewCount: 69,
  isInsider: true,
  description:
    "The Growing Candle® solves the problem of, “what to do with your candle container after your candle is gone?”\n\nAll of our eco-friendly candles are 100% pure soy and hand poured into ceramic planter pots. The twist that makes us unique, the labels around our candles have wildflower seeds embedded into them. After you are done melting down the candle, simply fill the container up with soil, plant the label, and grow a little flower garden!\n\nWe are an earth loving company, in Toledo, OH, that is inspired by the concept of hygge + obsessed with taking care of our planet.\n\nBy making the focus of our candles about reusing the container to grow wildflowers, we hope to get more people thinking about how they can re-use items before they end up in the landfill.\n\nTo legitimize our commitment to people + planet, we are proud to announce Hyggelight is a part of 1% for the Planet and is a B-Corporation.",
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:06:20.783Z",
    importedBy: "entity-db-cli",
  },
};
